import { SxProps, Theme } from '@mui/system';

const size = 50;

const styles = {

  avatar: {
    borderRadius: size / 2,
    height: size,
    width: size,
    border: '1px solid',
    objectFit: 'contain',
    borderColor: '#E1E4EF',
    mr: '12px',
  },

  fit: {
    objectFit: 'cover',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
